export default "/_next/static/images/ef011575a2a997af0245e2c425da3d53.jpg";